import type { Hookable } from 'hookable'

import type { KanbanBoardContextEvents } from '../useKanbanBoardContext.events.schema'

type KanbanBoardContextHookMap = {
  [K in keyof KanbanBoardContextEvents]: (event: KanbanBoardContextEvents[K]) => void | Promise<void>
}

/**
 * Handle for removing a previously registered kanban board context hook.
 */
type KanbanBoardContextUnsubscribe = () => void

interface KanbanBoardContextLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

interface UseKanbanBoardContextOnPlanIdChangedParams {
  hooks: Hookable<KanbanBoardContextHookMap>
  logger: KanbanBoardContextLoggerLike
}

/**
 * Internal handler: provides a centralized hook point for plan route changes.
 */
export default function useKanbanBoardContextOnPlanIdChanged({
  hooks,
  logger,
}: UseKanbanBoardContextOnPlanIdChangedParams) {
  const unsubscribe: KanbanBoardContextUnsubscribe = hooks.hook(
    'PlanIdChanged',
    ({ harmonyPlanId, previousHarmonyPlanId, path }) => {
      logger.debug('Kanban board plan route param changed', {
        path,
        previousHarmonyPlanId,
        harmonyPlanId,
      })
    },
  )

  return unsubscribe
}
